import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays the product badges on top of the product media gallery.
 * The badges are rendered by the `product-card-badges` snippet, so the updated markup is
 * taken from the re-rendered section that comes with the variant update event.
 */
class ProductGalleryBadges extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  /**
   * Updates the badges to match the selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadges = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadges = event.detail.data.html.querySelector(
      `product-gallery-badges[data-block-id="${this.dataset.blockId}"]`
    );

    this.innerHTML = newBadges ? newBadges.innerHTML : '';
  };
}

if (!customElements.get('product-gallery-badges')) {
  customElements.define('product-gallery-badges', ProductGalleryBadges);
}
